/**
 * Yerel (Türkiye) gün sınırlarının ISO karşılığı — sunucuya tarih filtresi
 * gönderirken. "YYYY-MM-DD" UTC gece yarısı olarak okunur ve 3 saat kayar (#242).
 */
export function localDayStartISO(date) {
  if (!date) return undefined;
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return undefined;
  d.setHours(0, 0, 0, 0);
  return d.toISOString();
}

export function localDayEndISO(date) {
  if (!date) return undefined;
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return undefined;
  d.setHours(23, 59, 59, 999);
  return d.toISOString();
}
